import { TableBody, TableCell } from "@mui/material";
import { styled } from "@mui/system";

export const StyledTableCell = styled(TableCell)(() => ({
  padding: "8px",
}));

export const StyledTableBody = styled(TableBody)(() => ({
  "& > *:nth-of-type(even)": {
    backgroundColor: "#FAFAFB",
  },
}));
